/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module PRINTER SELECTORS
 */

import _ from "lodash";
import { Map } from "immutable";

/**
 * Direct selector to the identity state domain
 */

const selectAppDomain = state => state.printer;

export const makeSelectInDataWithPathPrinter = (state, path = []) =>
  _.get(selectAppDomain(state), "data", Map()).getIn(path);
export const makeSelectInUiWithPathPrinter = (state, path = []) =>
  _.get(selectAppDomain(state), "ui", Map()).getIn(path);
